<script lang="ts">
	import { type Snippet } from 'svelte'
	interface Props {
		children?: Snippet
		class?: string
	}

	let { children, class: className = '' }: Props = $props()
</script>

<div
	class="{className}
	tw:inline-flex tw:flex-shrink-0
	tw:h-10 tw:*:h-10
	tw:*:text-shadow tw:*:no-underline tw:*:whitespace-nowrap
	tw:*:inline-flex tw:*:items-center tw:*:gap-2
	tw:*:px-3 tw:*:py-1.5
	tw:*:bg-gradient-to-b tw:*:from-yellow-500 tw:*:to-amber-500
	tw:*:disabled:from-yellow-300 tw:*:disabled:to-amber-300
	tw:*:disabled:hover:bg-yellow-300 tw:*:disabled:border-amber-300
	tw:*:bg-repeat-x tw:*:!text-white
	tw:*:border tw:*:border-yellow-600
	tw:*:hover:!text-white tw:*:hover:bg-amber-500 tw:*:hover:bg-[position:0_-34px] tw:*:hover:border-yellow-600
	tw:*:first:!rounded-l-md tw:*:first:rounded-r-none tw:*:last:rounded-l-none tw:*:last:!rounded-r-md tw:*:not-first:!-ml-[1px]">
	{@render children?.()}
</div>
